module.exports = __webpack_public_path__ + "img/filter-list.4fc9db2a.svg";